<template>
  <div class="mod-ask-bid">
    <OneTenChart
      :stock="stock"
      :prices="prices"
      :context="context"
      :show-data="showAskBidData"
      :bid-display-vol-percent="bidDisplayVolPercent"
      :ask-display-vol-percent="askDisplayVolPercent"
    />
  </div>
</template>
<script>
import isEmpty from 'lodash/isEmpty'
import OneTenChart from './OneTenChart'
import { fetchAStockAskBid, fetchHkStockAskBid } from 'apis/stock'
import { MARKET_TYPE, SEC_TYPE } from 'const/stock'
import isNeedRefresh from 'utils/isNeedRefresh'
import { TIMER_EXPRESSION } from 'const/common'
import askBidPricesPollMixin from './askBidPricesPollMixin'
export default {
  name: 'AskBidMod',
  components: {
    OneTenChart
  },
  mixins: [askBidPricesPollMixin],
  data() {
    return {
      prices: {
        ask: [],
        bid: []
      }
    }
  },
  props: {
    stock: Object,
    context: String
  },
  mounted() {
    this.initAskBid()
  },
  computed: {
    isHK() {
      return this.stock.market === MARKET_TYPE.HK
    },
    isUS() {
      return this.stock.market === MARKET_TYPE.US
    },
    isOPT() {
      return this.stock.secType === SEC_TYPE.OPT
    },
    isNeedRefresh() {
      return isNeedRefresh(this.stock, this.$store.getters)
    },
    totalAskVol() {
      if (!isEmpty(this.prices.ask)) {
        return this.prices.ask.reduce((acc, ask) => {
          return acc + (ask.volume ? ask.volume : 0)
        }, 0)
      }
      return 50
    },
    totalBidVol() {
      if (!isEmpty(this.prices.bid)) {
        return this.prices.bid.reduce((acc, bid) => {
          return acc + (bid.volume ? bid.volume : 0)
        }, 0)
      }
      // This is a placeholder amount if init load outruns data
      return 50
    },
    totalVolume() {
      return this.totalAskVol + this.totalBidVol
    },
    bidDisplayVolPercent() {
      const percent = ((this.totalBidVol / this.totalVolume) * 100).toFixed(2)
      if (isNaN(percent)) {
        return 0
      }
      return percent
    },
    askDisplayVolPercent() {
      const percent = ((this.totalAskVol / this.totalVolume) * 100).toFixed(2)
      if (isNaN(percent)) {
        return 0
      }
      return percent
    },
    showAskBidData() {
      const hasVolume = this.stock.bidSize > 0 || this.stock.askSize > 0
      if (this.isUS) {
        if (this.stock.secType === SEC_TYPE.OPT) {
          return hasVolume
        }
        return hasVolume
      }
      return true
    },
    symbol() {
      return this.stock.webLocal
        ? this.stock.webLocal.symbol
        : this.stock.symbol
    }
  },
  methods: {
    initAskBid() {
      if (this.timer) {
        this.timer.clear()
      }
      if (!this.showAskBidData) return
      this.refreshAskBid()
      if (this.isNeedRefresh) {
        const REFRESH_ASK_BID_STRING = 'refresh ask bid' + this.context
        const refreshRate = {
          OPT: TIMER_EXPRESSION.ASK_BID_OPT,
          STK: TIMER_EXPRESSION.ASK_BID_STK
        }
        this.timer = this.$cron(refreshRate[this.stock.secType]).interval(
          REFRESH_ASK_BID_STRING,
          this.refreshAskBid
        )
      }
    },
    refreshAskBid() {
      this.isUS ? this.getUsAskBid(this.stock) : this.getAorHkAskBid()
    },
    getUsAskBid(data) {
      this.prices.ask = [
        {
          price: data.askPrice || this.stock.askPrice,
          volume: data.askSize || this.stock.askSize
        }
      ]
      this.prices.bid = [
        {
          price: data.bidPrice || this.stock.bidPrice,
          volume: data.bidSize || this.stock.bidSize
        }
      ]
    },
    getAorHkAskBid() {
      if (this.isHK) {
        fetchHkStockAskBid(this.stock.symbol).then(res => {
          if (res.data.ret === 0) {
            this.prices.ask = res.data.ask || []
            this.prices.bid = res.data.bid || []
          }
        })
      } else {
        fetchAStockAskBid(this.stock.symbol).then(res => {
          if (res.data.ret === 0) {
            this.prices.ask = res.data.ask || []
            this.prices.bid = res.data.bid || []
          }
        })
      }
    }
  },
  watch: {
    symbol() {
      this.initAskBid()
    },
    isNeedRefresh() {
      this.initAskBid()
    },
    showAskBidData() {
      window.setTimeout(() => {
        this.initAskBid()
      }, 1000)
    }
  },
  beforeDestroy() {
    if (this.timer) {
      this.timer.clear()
    }
  }
}
</script>
